export const RESTRICTION_REASON = 'Motivo de restricción';
export const NOTIFICATION_EMAIL = 'E-mail de notificación';
